import React, { useState } from "react";
import { Card, Table, Dropdown, ProgressBar } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
const ProjectsTable = () => {
  const { id } = useParams();
  const [selectedFilter, setSelectedFilter] = useState("September");

  const projects = [
    {
      id: "PRO-001",
      name: "Office Management App",
      team: [
        "/assets/img/profiles/avatar-02-1.jpg",
        "/assets/img/profiles/avatar-03.jpg",
        "/assets/img/profiles/avatar-05.jpg",
      ],
      hours: "15/255 Hrs",
      progress: 40,
      priority: "High",
    },
    {
      id: "PRO-002",
      name: "Clinic Management",
      team: [
        "/assets/img/profiles/avatar-06-1.jpg",
        "/assets/img/profiles/avatar-07-1.jpg",
        "/assets/img/profiles/avatar-08-1.jpg",
      ],
      extra: "+1",
      hours: "15/255 Hrs",
      progress: 40,
      priority: "Low",
    },
    {
      id: "PRO-003",
      name: "Educational Platform",
      team: [
        "/assets/img/profiles/avatar-06-1.jpg",
        "/assets/img/profiles/avatar-08-1.jpg",
        "/assets/img/profiles/avatar-09.jpg",
      ],
      hours: "40/255 Hrs",
      progress: 50,
      priority: "Medium",
    },
    {
      id: "PRO-004",
      name: "Chat & Call Mobile App",
      team: [
        "/assets/img/profiles/avatar-11.jpg",
        "/assets/img/profiles/avatar-12-1.jpg",
        "/assets/img/profiles/avatar-13-1.jpg",
      ],
      hours: "35/155 Hrs",
      progress: 50,
      priority: "High",
    },
    {
      id: "PRO-005",
      name: "Travel Planning Website",
      team: [
        "/assets/img/profiles/avatar-17.jpg",
        "/assets/img/profiles/avatar-18.jpg",
        "/assets/img/profiles/avatar-19.jpg",
      ],
      hours: "50/235 Hrs",
      progress: 50,
      priority: "Medium",
    },
    {
      id: "PRO-006",
      name: "Service Booking Software",
      team: [
        "/assets/img/profiles/avatar-06-1.jpg",
        "/assets/img/profiles/avatar-08-1.jpg",
        "/assets/img/profiles/avatar-09.jpg",
      ],
      hours: "40/255 Hrs",
      progress: 50,
      priority: "Low",
    },
    {
      id: "PRO-008",
      name: "Travel Planning Website",
      team: [
        "/assets/img/profiles/avatar-15-1.jpg",
        "/assets/img/profiles/avatar-16.jpg",
        "/assets/img/profiles/avatar-17.jpg",
      ],
      extra: "+2",
      hours: "15/255 Hrs",
      progress: 45,
      priority: "Medium",
    },
      {
      id: "PRO-006",
      name: "Service Booking Software",
      team: [
        "/assets/img/profiles/avatar-06-1.jpg",
        "/assets/img/profiles/avatar-08-1.jpg",
        "/assets/img/profiles/avatar-09.jpg",
      ],
      hours: "40/255 Hrs",
      progress: 50,
      priority: "Low",
    },
    
  ];

  const getPriorityClass = (priority) => {
    if (priority === "High") return "priority-high";
    if (priority === "Low") return "priority-low";
    return "priority-medium";
  };

  return (
    <>
      <style>{`

      .projects-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
      }

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

      .project-id{
        color:#0d6efd;
        font-weight:500;
      }

      .project-name{
        font-weight:500;
      }

      .avatar-group{
        display:flex;
        align-items:center;
      }

      .avatar-img{
        width:30px;
        height:30px;
        border-radius:50%;
        border:2px solid #fff;
        margin-left:-8px;
        object-fit:cover;
      }

      .avatar-img:first-child{
        margin-left:0;
      }

      .avatar-extra{
        width:30px;
        height:30px;
        background:#ff6b2c;
        color:#fff;
        border-radius:50%;
        font-size:12px;
        display:flex;
        align-items:center;
        justify-content:center;
        margin-left:-8px;
        font-weight:600;
      }

      .hours-text{
        font-size:13px;
      }

      .progress-xs{
        height:6px;
        color:"#e55612"
      }

      .priority-badge{
        padding:4px 10px;
        border-radius:6px;
        font-size:12px;
        font-weight:500;
        display:inline-flex;
        align-items:center;
        gap:4px;
      }

      .priority-high{
        background:#ff4d4f;
        color:white;
      }

      .priority-low{
        background:#22c55e;
        color:white;
      }

      .priority-medium{
        background:#ec4899;
        color:white;
      }

      .dropdown-toggle{
        background:white !important;
        color:#333 !important;
      }
        button.btn-primary:hover{
background:#e55612;
}

      @media(max-width:768px){

        .avatar-img{
          width:26px;
          height:26px;
        }

        .avatar-extra{
          width:26px;
          height:26px;
        }

      }

      `}</style>

      <Card className="projects-card h-100">

        <Card.Header className="d-flex justify-content-between align-items-center flex-wrap card-header-custom">

          <h5 className="mb-2">Projects</h5>

          <Dropdown>

            <Dropdown.Toggle className="btn border btn-sm d-flex align-items-center bg-white text-dark">
              <FiCalendar className="me-1" />
              {selectedFilter}
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">

              <Dropdown.Item onClick={() => setSelectedFilter("This Month")}>
                This Month
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setSelectedFilter("This Week")}>
                This Week
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setSelectedFilter("Today")}>
                Today
              </Dropdown.Item>

            </Dropdown.Menu>

          </Dropdown>

        </Card.Header>

        <Card.Body className="p-0">

          <div className="table-responsive">

            <Table className="mb-0 align-middle">

              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Team</th>
                  <th>Hours</th>
                  <th>Priority</th>
                </tr>
              </thead>

              <tbody>

                {projects.map((project, index) => (

                  <tr key={index}>

                    <td className="project-id">{project.id}</td>

                    <td className="project-name">

                        <Link
    to={`/project-details/${project.id}`} 
    className="text-decoration-none text-dark"
  >
    {project.name}
  </Link>
                    </td>

                    <td>

                      <div className="avatar-group">

                        {project.team.map((img, i) => (
                          <img
                            key={i}
                            src={img}
                            alt="team"
                            className="avatar-img"
                          />
                        ))}

                        {project.extra && (
                          <span className="avatar-extra">
                            {project.extra}
                          </span>
                        )}

                      </div>

                    </td>

                    <td style={{minWidth:"160px"}}>

                      <p className="mb-1 hours-text">{project.hours}</p>

                      <ProgressBar
                        now={project.progress}
                        className="progress-xs"
                      />

                    </td>

                    <td>

                      <span className={`priority-badge ${getPriorityClass(project.priority)}`}>
                        ● {project.priority}
                      </span>

                    </td>

                  </tr>

                ))}

              </tbody>

            </Table>

          </div>

        </Card.Body>

      </Card>

    </>
  );
};

export default ProjectsTable;